import { useEffect, useState } from 'react';
import storage from './Global';

export default function useWhiteLabel() {
    const [whiteLabel, setWhiteLabel] = useState();

    useEffect(() => {
        const initial = storage.get('CompanyBranding');
        if (initial) {
            setWhiteLabel({ ...initial });
            return;
        }

        const interval = setInterval(() => {
            const stored = storage.get('CompanyBranding');
            if (stored) {
                setWhiteLabel({ ...stored });
                clearInterval(interval);
            }
        }, 100);

        return () => clearInterval(interval);
    }, []);

    return whiteLabel;
}